__turbopack_context__.v({
  "container": "Card-module__86LueG__container",
  "light": "Card-module__86LueG__light",
  "shadow": "Card-module__86LueG__shadow",
  "size-small": "Card-module__86LueG__size-small",
  "subtle": "Card-module__86LueG__subtle",
});
